

export class POIAlertReportOutputDataData implements IPOIAlertReportOutputDataData {
    /** The vehicle number */
    vehicle_number!: string;
    /** The vehicle name */
    vehicle_name!: string;
    /** The place name */
    place_name!: string;
    /** The in date and time */
    in_date!: string;
    /** The out date and time */
    out_date!: string;
    /** The total duration */
    duration!: string;

    constructor(data?: IPOIAlertReportOutputDataData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicle_number = _data["vehicle_number"];
            this.vehicle_name = _data["vehicle_name"];
            this.place_name = _data["place_name"];
            this.in_date = _data["in_date"];
            this.out_date = _data["out_date"];
            this.duration = _data["duration"];
        }
    }

    static fromJS(data: any): POIAlertReportOutputDataData {
        data = typeof data === 'object' ? data : {};
        let result = new POIAlertReportOutputDataData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicle_number"] = this.vehicle_number;
        data["vehicle_name"] = this.vehicle_name;
        data["place_name"] = this.place_name;
        data["in_date"] = this.in_date;
        data["out_date"] = this.out_date;
        data["duration"] = this.duration;
        return data; 
    }
}

export interface IPOIAlertReportOutputDataData {
    /** The vehicle number */
    vehicle_number: string;
    /** The vehicle name */
    vehicle_name: string;
    /** The place name */
    place_name: string;
    /** The in date and time */
    in_date: string;
    /** The out date and time */
    out_date: string;
    /** The total duration */
    duration: string;
}

